import { render, staticRenderFns } from "./registrarDepodepo.vue?vue&type=template&id=678896ad"
import script from "./registrarDepodepo.vue?vue&type=script&lang=js"
export * from "./registrarDepodepo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports